(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
(function () {
  // Shopify's recommendations come in a second request; this places them. In "new" mode it keeps only the same kind of
  // item as this product (Similar items) and leaves out anything already in Goes well with this. If fewer than 2 are
  // left, it shows Shopify's own picks under the old heading instead, so the area is never empty.
  function fit(grid, count, max) {
    // Fewer cards than a full row: normal card size, centred.
    grid.className = grid.className.replace(/product-grid--per-row-\d+(?!-)/, 'product-grid--per-row-' + Math.max(count, 1));
    if (count < max) { grid.style.maxWidth = Math.round(count / max * 100) + '%'; grid.style.marginLeft = 'auto'; grid.style.marginRight = 'auto'; }
    else { grid.style.maxWidth = ''; grid.style.marginLeft = ''; grid.style.marginRight = ''; }
  }

  // A computer: more cards than fit -> one row that slides, with < > arrows (a phone swipes - .jhr-swipe).
  // visible = cards shown at once (2 in each half when side by side, else the section's cards per row).
  var CHEV = { prev: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M15 5l-7 7 7 7"/></svg>',
    next: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M9 5l7 7-7 7"/></svg>' };
  // always = side by side: both halves use the SAME card width even when one has only 2 (so the names line up exactly)
  function slider(grid, visible, always) {
    if (!grid) return;
    var n = grid.querySelectorAll(':scope > product-block').length;
    grid.style.setProperty('--jhr-vis', visible);
    var wrap = grid.parentNode;
    if (n <= visible && !always) { grid.classList.remove('jhr-slide'); return; }
    grid.classList.add('jhr-slide');
    grid.style.maxWidth = ''; grid.style.marginLeft = ''; grid.style.marginRight = '';
    if (n <= visible) return;                        // all showing: no arrows
    wrap.classList.add('jhr-slide-wrap');
    if (wrap.querySelector('.jhr-recs__arrow')) { grid.dispatchEvent(new Event('scroll')); return; }
    var title = (wrap.closest('.jhr-recs__row') || {}).querySelector ? wrap.closest('.jhr-recs__row').querySelector('h4') : null;
    var what = title && title.textContent ? title.textContent.trim().toLowerCase() : 'products';
    function arrow(dir) {
      var b = document.createElement('button'); b.type = 'button'; b.className = 'jhr-recs__arrow jhr-recs__arrow--' + dir;
      b.setAttribute('aria-label', (dir === 'prev' ? 'Back through ' : 'More ') + what);
      b.innerHTML = CHEV[dir];
      b.addEventListener('click', function () {
        // one "page" = the cards on show + the gap after them; glide there, and jump if the browser doesn't glide
        var from = grid.scrollLeft, by = (dir === 'prev' ? -1 : 1) * (grid.clientWidth + 24);
        grid.scrollTo({ left: from + by, behavior: 'smooth' });
        setTimeout(function () { if (Math.abs(grid.scrollLeft - from) < 2) grid.scrollTo({ left: from + by, behavior: 'auto' }); update(); }, 450);
        setTimeout(update, 900);                       // and grey out / bring back the arrows even if no scroll event comes
      });
      wrap.appendChild(b); return b;
    }
    var prev = arrow('prev'), next = arrow('next');
    function update() { var end = grid.scrollWidth - grid.clientWidth - 2; prev.disabled = grid.scrollLeft <= 2; next.disabled = grid.scrollLeft >= end; }
    grid.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  // 2 Oct 2026 (Aaron: "sometimes it's only bringing up two items or none at all"): Shopify hands over 10 suggestions
  // and only those of the SAME kind are kept - often 0-3 (a velvet show hat: 0 hats; Comfey jodhpur boots: 1). When
  // fewer than TOPUP_BELOW are left, the row tops itself up from the shop's own search for that product type, in stock,
  // best sellers first (templates/search.jhr-similar.liquid), Shopify's own picks first.
  var TOPUP_BELOW = 6;
  var SIMILAR_MAX = 10;
  function topUp(type, have, exclude) {
    if (!type || have.length >= TOPUP_BELOW) return Promise.resolve(have);
    var url = '/search?type=product&view=jhr-similar&q=' + encodeURIComponent('product_type:"' + type + '"');
    return fetch(url).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
      var box = document.createElement('div');
      box.innerHTML = html;
      var types = {};
      try { types = JSON.parse((box.querySelector('[data-jhr-recs-types]') || {}).textContent || '{}'); } catch (e) { types = {}; }
      var ids = have.map(function (c) { return c.dataset.productId; });
      var out = have.slice();
      Array.prototype.slice.call(box.querySelectorAll('.jhr-recs__pool product-block[data-product-id]')).forEach(function (c) {
        var id = c.dataset.productId;
        if (out.length >= SIMILAR_MAX || ids.indexOf(id) !== -1 || exclude.indexOf(id) !== -1) return;
        if ((types[id] || '') !== type) return;          // exactly the same kind, as with Shopify's own
        ids.push(id);
        out.push(c);
      });
      return out;
    }).catch(function () { return have; });
  }

  function place(section, reply) {
    var row = section.querySelector('[data-jhr-recs-row="similar"]');
    if (!row) return;
    var pool = reply.querySelector('.jhr-recs__pool');
    if (!pool) return;
    var types = {};
    try { types = JSON.parse((reply.querySelector('[data-jhr-recs-types]') || {}).textContent || '{}'); } catch (e) { types = {}; }
    var exclude = (row.dataset.exclude || '').split(',');
    var cards = Array.prototype.slice.call(pool.querySelectorAll('product-block[data-product-id]'))
      .filter(function (c) { return exclude.indexOf(c.dataset.productId) === -1; });
    var isNew = section.dataset.jhrRecsMode === 'new';
    // Englander items of this kind first (they are in data-exclude, so Shopify's picks never repeat them)
    var own = Array.prototype.slice.call(row.querySelectorAll('.jhr-recs__own product-block[data-product-id]'));
    var same = isNew ? own.concat(cards.filter(function (c) { return row.dataset.type !== '' && (types[c.dataset.productId] || '') === row.dataset.type; })) : [];
    if (!isNew) { show(section, row, cards, same, isNew); return; }
    topUp(row.dataset.type, same, exclude).then(function (filled) { show(section, row, cards, filled, isNew); });
  }

  function show(section, row, cards, same, isNew) {
    var max = parseInt(section.dataset.max, 10) || 4;
    var gw = section.querySelector('[data-jhr-recs-row="goes_well"]');
    var grid = row.querySelector('.product-grid');

    if (isNew && same.length >= 2) {
      row.querySelector('h4').textContent = row.dataset.titleSimilar;
      var take = same.slice(0, 10);
      take.forEach(function (c) { grid.appendChild(c); });
      if (take.length > 2) grid.classList.add('jhr-swipe');          // phone: swipe sideways
      row.hidden = false;
      if (gw) {
        // Both rows: side by side on a computer, 2 cards at a time in each, arrows for the rest (phone: swipe).
        fit(grid, 2, 2);
        fit(gw.querySelector('.product-grid'), 2, 2);
        section.querySelector('.jhr-recs__pair').classList.add('is-pair');
        slider(grid, 2, true);
        slider(gw.querySelector('.product-grid'), 2, true);
      } else {
        fit(grid, Math.min(take.length, max), max);
        slider(grid, max);
      }
      return;
    }
    if (gw) { slider(gw.querySelector('.product-grid'), max); return; }   // Goes well with this fills the area on its own
    var own = isNew ? Array.prototype.slice.call(row.querySelectorAll('.jhr-recs__own product-block[data-product-id]')) : [];
    var rest = own.concat(cards).slice(0, max);       // never empty: Shopify's own picks, as before (ours first)
    if (!rest.length) return;
    rest.forEach(function (c) { grid.appendChild(c); });
    if (rest.length > 2) grid.classList.add('jhr-swipe');
    fit(grid, rest.length, max);
    row.querySelector('h4').textContent = row.dataset.titleOld;
    row.hidden = false;
  }

  function load() {
    var section = document.querySelector('.related-products.jhr-recs');
    if (!section || !section.dataset.url) return;
    // Goes well with this, on its own until the recommendations arrive (and if they never do): a full row that slides
    slider(section.querySelector('[data-jhr-recs-row="goes_well"] .product-grid'), parseInt(section.dataset.max, 10) || 4);
    var request = new XMLHttpRequest();
    request.open('GET', section.dataset.url);
    request.onload = function () {
      if (request.status >= 200 && request.status < 300) {
        var reply = document.createElement('div');
        reply.innerHTML = request.response;
        place(section, reply);
      }
    };
    request.send();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) load();
  });
  load();
})();

  } catch(e) { console.error(e); }
})();
})();
